module.exports = __webpack_public_path__ + "static/media/silent.2777c1a0.wav";